import React from "react"
import ReactDOM from "react-dom"
import { ThemeProvider } from "@material-ui/core"
import * as Sentry from '@sentry/browser';

import App from "./App"

import theme from "./styles/theme"
import GlobalStyles from "./styles/global"

Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN, environment: process.env.REACT_APP_SENTRY_ENVIRONMENT });

ReactDOM.render(
	<ThemeProvider theme={theme}>
		<GlobalStyles />
		<App />
	</ThemeProvider>,
	document.getElementById("root")
)
